import { fromJS, merge } from 'immutable';
import { FluxStandardAction } from '__utils/type';
import * as Actions from 'constants/actions';
export interface profileViewState {
    sinaturePicUrl: any;
    uploadImageError: unknown;
    encRequirementId?: any;
}
const rawState: profileViewState = {
    sinaturePicUrl: "",
    uploadImageError: null,
};

const intialState = fromJS(rawState);

export default function OccupationDetailsReducer (
    state = intialState,
    action: FluxStandardAction
) {
    switch (action.type)
    {
        case Actions.FETCH_POST_CANCEL_UPLOAD_CHEQUE_SUCCESS:
            return merge(state, fromJS({ sinaturePicUrl: action.payload.data }));
        case Actions.FETCH_POST_CANCEL_UPLOAD_CHEQUE_FAILURE:
            return merge(state, fromJS({ uploadImageError: action.payload.data }));
        case Actions.SET_ENC_REQUIREMENT_ID:
            return merge(state, fromJS({ encRequirementId: action.payload }));
        default:
            return state;
    }
}
